<template>
    <v-container grid-list-md fluid>
        <v-layout row wrap>
            <confirmation
            :visible="isRemoveImage"
            :message="'Are you sure to remove?'"
            @clicked="onConfirmRemoveImageVideo($event, 'image')"
            @close="isRemoveImage=false;"
            />
            
            <confirmation
            :visible="isRemovePromotionImage"
            :message="'Are you sure to remove?'"
            @clicked="onConfirmRemoveImageVideo($event, 'promotionImage')"
            @close="isRemovePromotionImage=false;"
            />
            
            <confirmation
            :visible="isRemoveVideo"
            :message="'Are you sure to remove?'"
            @clicked="onConfirmRemoveImageVideo($event, 'video')"
            @close="isRemoveVideo=false"
            />

            <confirmation
            :visible="isRemoveOverview"
            :message="'Are you sure to remove?'"
            @clicked="onConfirmRemoveOverview"
            @close="isRemoveOverview=false"
            />
            
            <confirmation
            :visible="isRemoveDirection"
            :message="'Are you sure to remove?'"
            @clicked="onConfirmRemoveDirection"
            @close="isRemoveDirection=false"
            />
            
            <confirmation
            :visible="isRemoveIngredient"
            :message="'Are you sure to remove?'"
            @clicked="onConfirmRemoveIngredient"
            @close="isRemoveIngredient=false"
            />
            
            <confirmation
            :visible="isRemovePromotion"
            :message="'Are you sure to remove?'"
            @clicked="onConfirmRemovePromotion"
            @close="isRemovePromotion=false"
            />

            <v-flex xs12 sm12 md12 lg12>
                <v-form ref="form" id="recipeForm">
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12 lg12>
                            <!-- Recipe Info -->
                            <v-card>
                                <v-toolbar color="light-blue lighten-4" light>
                                    <v-toolbar-title>Recipe Information</v-toolbar-title>
                                </v-toolbar>
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm12 md6 lg6>
                                            <v-text-field v-model="recipeInfoModel.name" :rules="recipeRules.name" :type="'text'" label="Recipe Name*" required @input="validateRecipeForm"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12 md6 lg6>
                                            <v-text-field v-model="recipeInfoModel.author" :rules="recipeRules.author" :type="'text'" label="Author*" required=""  @input="validateRecipeForm"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12 lg12>
                                            <h4>Image</h4>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm9 md9 lg9>
                                                    <div class="preview">
                                                        <v-progress-circular
                                                            :rotate="360"
                                                            :size="100"
                                                            :width="15"
                                                            :value="imageUploadProgress"
                                                            color="teal"
                                                            v-if="isUploadingImage"
                                                            >
                                                            {{ imageUploadProgress }}
                                                        </v-progress-circular>
                                                        <img :src="recipeInfoModel.image" height="150" v-if="recipeInfoModel.image && !isUploadingImage"/>
                                                    </div>
                                                    <v-btn depressed block large color="default" @click="isRemoveImage = true;" v-if="recipeInfoModel.image">Remove</v-btn>
                                                </v-flex>

                                                <v-flex xs12 sm3 md3 lg3>
                                                    <!-- <v-icon :disabled="isUploadingImage || isUploadingVideo" class="float-right pointer green--text" @click="pickImageFile">attach_file</v-icon> -->

                                                    <v-btn :disabled="isUploadingImage || isUploadingVideo" depressed block large color="success" @click="pickImageFile">{{(recipeInfoModel.image)? 'Update' : 'Add'}}</v-btn>
                                                    
                                                    <input
                                                        type="file"
                                                        ref="image"
                                                        class="hidden"
                                                        accept="image/*"
                                                        @change="onFilePicked($event, 'image')">
                                                </v-flex>
                                             </v-layout>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12 lg12>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm9 md9 lg9>
                                                    <v-text-field v-model="recipeInfoModel.video" :type="'text'" label="Video"></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm9 md9 lg9>
                                                    <div class="preview">
                                                        <v-progress-circular
                                                            :rotate="360"
                                                            :size="100"
                                                            :width="15"
                                                            :value="videoUploadProgress"
                                                            color="teal"
                                                            v-if="isUploadingVideo"
                                                            >
                                                            {{ videoUploadProgress }}
                                                        </v-progress-circular>

                                                        <!-- <video controls>
                                                            <source type="video/mp4" :src="recipeInfoModel.video">
                                                        </video> -->

                                                        <video v-if="!isUploadingVideo" ref="videoRef" :src="recipeInfoModel.video" id="video-container" width="100%" controls></video>
                                                    </div>
                                                    <v-btn depressed block large color="default" @click="isRemoveVideo = true" v-if="recipeInfoModel.video">Remove</v-btn>
                                                </v-flex>

                                                <v-flex xs12 sm3 md3 lg3>
                                                    <!-- <v-icon :disabled="isUploadingImage || isUploadingVideo" class="float-right pointer green--text" @click="pickVideoFile">attach_file</v-icon> -->


                                                    <v-btn :disabled="isUploadingImage || isUploadingVideo" depressed block large color="success" @click="pickVideoFile">{{(recipeInfoModel.video)? 'Update' : 'Add'}}</v-btn>

                                                    <input
                                                        type="file"
                                                        ref="video"
                                                        class="hidden"
                                                        accept="video/mp4,video/x-m4v,video/*"
                                                        @change="onFilePicked($event, 'video')">
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        
                                        
                                        <v-flex xs12 sm6 md3 lg3>
                                            <v-select
                                                :items="recipeLevelItems"
                                                :rules="recipeRules.recipe_level"
                                                v-model="recipeInfoModel.recipe_level"
                                                label="Recipe Level*"
                                                item-value="value"
                                                required=""
                                                @change="validateRecipeForm"
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs12 sm6 md3 lg3>
                                            <v-select
                                                :items="recipeTypesItems"
                                                :rules="recipeRules.type"
                                                v-model="recipeInfoModel.type"
                                                label="Type*"
                                                item-value="value"
                                                required=""
                                                @change="validateRecipeForm"
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs12 sm6 md3 lg3>
                                            <v-select
                                                :items="skillLevelItems"
                                                :rules="recipeRules.skill_level"
                                                v-model="recipeInfoModel.skill_level"
                                                label="Skill Level*"
                                                item-value="value"
                                                required=""
                                                @change="validateRecipeForm"
                                            ></v-select>
                                        </v-flex>
                                        
                                        <v-flex xs12 sm12 md3 lg3>
                                            <v-select
                                                :items="cookTimeItems"
                                                :rules="recipeRules.cook_time"
                                                v-model="recipeInfoModel.cook_time"
                                                label="Cook Time*"
                                                item-value="value"
                                                required=""
                                                @change="validateRecipeForm"
                                            ></v-select>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12 lg12 v-if="toggleOverview == true">
                                            <h4>Overview</h4>
                                            <ul v-sortable="{ onUpdate: onOverviewUpdate }" class="sortable-list padL0">
                                                <li v-for="(item, i) in recipeInfoModel.overview" :key="i">
                                                    <v-layout row wrap>
                                                        <v-flex xs8 sm8 md10 lg10>
                                                            <v-textarea v-model="recipeInfoModel.overview[i].name" label="" multi-line rows="2" @input="validateRecipeForm"></v-textarea>
                                                        </v-flex>
                                                        <v-flex xs4 sm4 md2 lg2>
                                                            <v-icon v-if="i > 0" class="float-right pointer">list</v-icon>
                                                            <v-icon v-if="i > 0" class="float-right pointer red--text" @click="addRemoveOverview(i, 'delete')">delete</v-icon>
                                                            <v-icon class="float-right pointer green--text" @click="addRemoveOverview(i, 'add')">add</v-icon>
                                                        </v-flex>
                                                    </v-layout>
                                                </li>
                                            </ul>
                                        </v-flex>
                                        
                                        <v-flex xs12 sm12 md12 lg12 v-if="toggleDirection == true">
                                            <h4>Directions</h4>
                                            
                                            <ul v-sortable="{ onUpdate: onDirectionUpdate }" class="sortable-list padL0">
                                                <li v-for="(item, i) in recipeInfoModel.directions" :key="i">
                                                    <v-layout row wrap>
                                                        <v-flex xs8 sm8 md10 lg10>
                                                            <v-textarea v-model="recipeInfoModel.directions[i].name" label="" multi-line rows="2" @input="validateRecipeForm"></v-textarea>
                                                        </v-flex>
                                                        <v-flex xs4 sm4 md2 lg2>
                                                            <v-icon v-if="i > 0" class="float-right pointer">list</v-icon>
                                                            <v-icon v-if="i > 0" class="float-right pointer red--text" @click="addRemoveDirection(i, 'delete')">delete</v-icon>
                                                            <v-icon class="float-right pointer green--text" @click="addRemoveDirection(i, 'add')">add</v-icon>
                                                        </v-flex>
                                                    </v-layout>
                                                </li>
                                            </ul>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12 lg12 v-if="toggleIngredients == true">
                                            <h4>Ingredients</h4>
                                            <ul v-sortable="{ onUpdate: onIngredientsUpdate }" class="sortable-list padL0">
                                                <li v-for="(item, i) in recipeInfoModel.ingredients" :key="i">
                                                    <v-layout row wrap>
                                                        <v-flex xs8 sm8 md10 lg10>
                                                            <v-layout row wrap>
                                                                <v-flex xs12 sm6 md6 lg6>
                                                                    <v-text-field v-model="recipeInfoModel.ingredients[i].name" :type="'text'" label="Item*" @input="validateRecipeForm"></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs6 sm3 md2 lg2>
                                                                    <v-select
                                                                        :items="wholeQtyItems"
                                                                        v-model="recipeInfoModel.ingredients[i].whole_quantity"
                                                                        label="Whole Qty"
                                                                        item-value="value"
                                                                        @change="validateRecipeForm"
                                                                    ></v-select>
                                                                </v-flex>
                                                                <v-flex xs6 sm3 md2 lg2>
                                                                    <v-select
                                                                        :items="partialQtyItems"
                                                                        v-model="recipeInfoModel.ingredients[i].partial_quantity"
                                                                        label="Partial Qty"
                                                                        item-value="value"
                                                                        @change="validateRecipeForm"
                                                                    ></v-select>
                                                                </v-flex>
                                                                <v-flex xs6 sm3 md2 lg2>
                                                                    <v-select
                                                                        :items="unitItems"
                                                                        v-model="recipeInfoModel.ingredients[i].unit"
                                                                        label="Unit"
                                                                        item-value="value"
                                                                        @change="validateRecipeForm"
                                                                    ></v-select>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs4 sm4 md2 lg2>
                                                            <v-icon v-if="i > 0" class="float-right pointer">list</v-icon>
                                                            <v-icon v-if="i > 0" class="float-right pointer red--text" @click="addRemoveIngredients(i, 'delete')">delete</v-icon>
                                                            <v-icon class="float-right pointer green--text" @click="addRemoveIngredients(i, 'add')">add</v-icon>
                                                        </v-flex>
                                                    </v-layout>
                                                </li>
                                            </ul>
                                        </v-flex>

                                        <v-flex xs6 sm6 md6 lg6>
                                            <v-text-field v-model="recipeInfoModel.weight" :type="'text'" label="Weight"></v-text-field>
                                        </v-flex>
                                        <v-flex xs6 sm6 md6 lg6>
                                            <v-text-field v-model="recipeInfoModel.energy" :type="'text'" label="Energy"></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12 lg12 v-if="togglePromotions == true">
                                            <h4>Promotions
                                                <v-icon class="float-right pointer green--text" @click="addRemovePromotions(0, 'add')">add</v-icon>
                                            </h4>
                                            <ul v-sortable="{ onUpdate: onPromotionsUpdate }" class="sortable-list padL0">
                                                <li v-for="(item, i) in recipeInfoModel.promotions" :key="i">
                                                    <v-layout row wrap>
                                                        <v-flex xs10 sm10 md3 lg3>
                                                            <v-layout row wrap>
                                                                <v-flex xs12 sm12 md12 lg12>
                                                                    <v-text-field v-model="recipeInfoModel.promotions[i].name" :type="'text'" label="Name" ></v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs10 sm10 md7 lg7>
                                                            <v-layout row wrap>
                                                                <v-flex xs12 sm12 md12 lg12>
                                                                    <v-text-field v-model="recipeInfoModel.promotions[i].url" :type="'text'" label="Url" ></v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs10 sm10 md10 lg10>
                                                            <v-layout row wrap>
                                                                <v-flex xs12 sm12 md12 lg12>

                                                                    <v-textarea v-model="recipeInfoModel.promotions[i].description" multi-line rows="2" @input="validateRecipeForm" label="Description"></v-textarea>

                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        
                                                        <v-flex xs2 sm2 md2 lg2>
                                                            <v-icon class="float-right pointer">list</v-icon>
                                                            <v-icon class="float-right pointer red--text" @click="addRemovePromotions(i, 'delete')">delete</v-icon>
                                                            <v-icon class="float-right pointer green--text" @click="addRemovePromotions(i, 'add')">add</v-icon>
                                                        </v-flex>

                                                        <v-flex xs12 sm12 md12 lg12>
                                                            <v-layout row wrap>
                                                                <v-flex xs12 sm9 md9 lg9>
                                                                    <h4>Promotion Image</h4>
                                                                    <div class="preview">
                                                                        <v-progress-circular
                                                                            :rotate="360"
                                                                            :size="100"
                                                                            :width="15"
                                                                            :value="promotionImageUploadProgress"
                                                                            color="teal"
                                                                            v-if="isUploadingPromotionImage"
                                                                            >
                                                                            {{ promotionImageUploadProgress }}
                                                                        </v-progress-circular>
                                                                        <img :src="recipeInfoModel.promotions[i].image" height="150" v-if="recipeInfoModel.promotions[i].image && !isUploadingPromotionImage"/>
                                                                    </div>
                                                                    <v-btn depressed block large color="default" @click="isRemovePromotionImage = true; promotionImageIndex = i;" v-if="recipeInfoModel.promotions[i].image">Remove</v-btn>
                                                                </v-flex>

                                                                <v-flex xs12 sm3 md3 lg3>
                                                                    <v-icon :disabled="isUploadingPromotionImage || isUploadingImage || isUploadingVideo" class="float-right pointer green--text" @click="pickPromotionImageFile(i)">attach_file</v-icon>
                                                                    <input
                                                                        type="file"
                                                                        ref="promotionImage"
                                                                        class="hidden"
                                                                        accept="image/*"
                                                                        @change="onFilePicked($event, 'promotionImage')">
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                </li>
                                            </ul>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12 lg12>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm6 md6 lg6>
                                                    <h4>Published Date : {{parseFirebaseTimestamp(recipeInfoModel.published_date)}}</h4>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6 lg6>
                                                    <v-select
                                                        :items="publishStatusItems"
                                                        :rules="recipeRules.publish_status"
                                                        v-model="recipeInfoModel.publish_status"
                                                        label="Publish Status*"
                                                        item-value="value"
                                                        required=""
                                                        @change="validateRecipeForm"
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-flex>

            <!-- Action Buttons -->
            <v-flex xs12 sm12 md12 lg12>
                <v-layout row wrap>

                    <v-flex xs6 lg6>
                        <v-btn depressed block large color="success" :disabled="!isValidRecipeForm || isUploadingImage || isUploadingVideo || isUploadingPromotionImage" @click="saveRecipe()">Save</v-btn>
                    </v-flex>   

                    <v-flex xs6 lg6>
                        <v-btn depressed block large color="secondary" @click="goToRecipes()">Cancel</v-btn>
                    </v-flex>

                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import Utils from '@/services/Utils.js';
    import CONSTANT from "@/services/Constant.js";
    import confirmation from "@/components/common/Confirmation.vue";
    import firebase from 'firebase';
    import RecipeService from "@/services/db/RecipeService.js";
    import DateRecipeService from "@/services/db/DateRecipeService.js";
    import SettingService from "@/services/db/SettingService.js";

    export default {
        name: "AddRecipe",
        components: {
            confirmation
        },
        props: ["id"],
        data() {
            return {
                title: "Add Recipes",
                isRemoveImage: false,
                isRemovePromotionImage: false,
                isRemoveVideo: false,
                isRemoveOverview: false,
                removeOverviewPosition: -1,
                isRemoveDirection: false,
                removeDirectionPosition: -1,
                isRemoveIngredient: false,
                removeIngredientPosition: -1,
                isRemovePromotion: false,
                removePromotionPosition: -1,
                isSavingRecipe: false,
                isUploadingImage: false,
                isUploadingPromotionImage: false,
                isUploadingVideo: false,
                imageUploadProgress: 0,
                promotionImageUploadProgress: 0,
                videoUploadProgress: 0,
                isValidRecipeForm : false,
                isEditMode: false,
                recipeInfoModel: this.getDefaultRecipe(),
                currentRecipeInfoModel: {},
                recipeRules: {
                    name: [
                        v => !!v || 'Recipe Name is required',
                    ],
                    author: [
                        v => !!v || 'Author is required',
                    ],
                    type: [
                        v => !!v || 'Type is required',
                    ],
                    skill_level: [
                        v => !!v || 'Skill Level is required',                  
                    ],
                    publish_status: [
                        v => !!v || 'Publish status is required',                  
                    ],
                    cook_time: [
                        v => !!v || 'Cook time is required',
                    ]
                },
                cookTimeItems: CONSTANT.LIST.TIME_LIST,
                recipeTypesItems: CONSTANT.LIST.RECIPE_TYPES,
                skillLevelItems: [],
                recipeLevelItems: [],
                wholeQtyItems: [],
                partialQtyItems: [],
                unitItems: [],
                publishStatusItems: CONSTANT.LIST.PUBLISH_STATUS_LIST,
                imageName: '',
                imageUrl: '',
                imageFile: '',
                promotionImageName: '',
                promotionImageUrl: '',
                promotionImageFile: '',
                promotionImageIndex: 0,
                videoName: '',
                videoUrl: '',
                videoFile: '',
                toggleOverview: true,
                toggleDirection: true,
                toggleIngredients: true,
                togglePromotions: true,
                BREAKFAST: 'breakfast',
                DINNER: 'dinner',
                LUNCH: 'lunch',
            }
        },
        created() {

            this.loadSettingsByKey(CONSTANT.APP_SETTING_KEYS.UNITS);
            this.loadSettingsByKey(CONSTANT.APP_SETTING_KEYS.SKILL_LEVEL);
            this.loadSettingsByKey(CONSTANT.APP_SETTING_KEYS.RECIPE_LEVEL);
            this.loadSettingsByKey(CONSTANT.APP_SETTING_KEYS.QUANTITY);

            if (this.id) {
                this.loadRecipeById(this.id);
            } else {
                this.recipeInfoModel = this.getDefaultRecipe();
                this.isEditMode = false;
            }
            if(this.recipeInfoModel.overview && this.recipeInfoModel.overview.length <= 0){
                this.addRemoveOverview(0, 'add');
            }
            if(this.recipeInfoModel.directions && this.recipeInfoModel.directions.length <= 0){
                this.addRemoveDirection(0, 'add');
            }
            if(this.recipeInfoModel.ingredients && this.recipeInfoModel.ingredients.length <= 0){
                this.addRemoveIngredients(0, 'add');
            }
            if(this.recipeInfoModel.promotions && this.recipeInfoModel.promotions.length <= 0){
                // this.addRemovePromotions(0, 'add');
            }
        },
        methods: {
            // --------------------
            // LOAD DATA
            // --------------------

            // --------------------
            // Method to get default recipe model value
            // --------------------
            getDefaultRecipe() {
                return {
                    user_id: "",
                    name: "",
                    author: "",
                    directions: [],
                    energy: "",
                    image: "",
                    video: "",
                    ingredients: [],
                    cook_time: "",
                    overview: [],
                    published_date: Utils.getFirebaseTimestamp(),
                    skill_level: "",
                    recipe_level: "",
                    type: "",
                    promotions:[],
                    random: Utils.generateRandomByInteger(6),
                    weight: "",
                    publish_status: "pending"
                };
            },

            // --------------------
            // Method to load existing recipe by id
            // --------------------
            loadRecipeById(id){
                RecipeService.getRecipeById(id, (recipe) => {
                    
                    if (recipe) {
                        this.recipeInfoModel = Object.assign({}, recipe);

                        this.recipeInfoModel.id = id;

                        if(Utils.isNullOrUndefined(this.currentRecipeInfoModel['id'])){
                            this.currentRecipeInfoModel = Object.assign({}, this.recipeInfoModel);
                        }
                        
                        this.setDirectionValues();
                        this.setOverviewValues();
                        this.setPromotionValues();

                        if(this.$refs.videoRef){
                            this.$refs.videoRef.src = this.recipeInfoModel['video'];
                        }
                        // this.$refs.videoRef.play();
                        this.validateRecipeForm();

                    } else {
                        setTimeout(() => {
                            this.$router.push(
                                `/recipes`
                            );
                        }, 1000);
                    }
                });   

                this.isEditMode = true;
            },

            setOverviewValues(){
                if(this.recipeInfoModel['overview'] && this.recipeInfoModel['overview'].length > 0){
                    var _overviews = this.recipeInfoModel['overview'];
                    this.recipeInfoModel['overview'] = [];
                    _overviews.forEach((direct) => {
                        this.recipeInfoModel['overview'].push({
                            "name": direct
                        });
                    });
                } else {
                    this.addRemoveOverview(0, 'add');
                }
            },
            
            setDirectionValues(){
                if(this.recipeInfoModel['directions'] && this.recipeInfoModel['directions'].length > 0){
                    var _directions = this.recipeInfoModel['directions'];
                    this.recipeInfoModel['directions'] = [];
                    _directions.forEach((direct) => {
                        this.recipeInfoModel['directions'].push({
                            "name": direct
                        });
                    });
                } else {
                    this.addRemoveDirection(0, 'add');
                }
            },
            
            setPromotionValues(){
                if(!this.recipeInfoModel['promotions'] || this.recipeInfoModel['promotions'].length <= 0){
                    // this.addRemovePromotions(0, 'add');
                }
            },

            // --------------------
            // Method to load setting value by key
            // --------------------
            loadSettingsByKey(key){

                SettingService.getSettingByKey(key).then((setting) => {
                    if(setting){
                        if(key == CONSTANT.APP_SETTING_KEYS.UNITS){
                            this.unitItems = setting.list;
                        }
                        if(key == CONSTANT.APP_SETTING_KEYS.SKILL_LEVEL){
                            this.skillLevelItems = setting.list;
                        }
                        if(key == CONSTANT.APP_SETTING_KEYS.RECIPE_LEVEL){
                            this.recipeLevelItems = setting.list;
                        }
                        if(key == CONSTANT.APP_SETTING_KEYS.QUANTITY){
                            this.wholeQtyItems = setting.list;
                            this.partialQtyItems = setting.partial_list;
                        }
                    }
                });
            },

            // Method to add/remove overview row
            addRemoveOverview(position, type){
                if(type == 'add'){
                    if(this.recipeInfoModel['overview'].length > 0){
                        position++;
                    }
                    var _obj = {
                        "name": ""
                    };
                    this.recipeInfoModel['overview'].splice(position, 0, _obj);
                } else {
                    this.isRemoveOverview = true;
                    this.removeOverviewPosition = position;
                    // this.recipeInfoModel['directions'].splice(position, 1);
                }
                this.validateRecipeForm();
            },
            
            // Method to add/remove direction row
            addRemoveDirection(position, type){
                if(type == 'add'){
                    if(this.recipeInfoModel['directions'].length > 0){
                        position++;
                    }
                    var _obj = {
                        "name": ""
                    };
                    this.recipeInfoModel['directions'].splice(position, 0, _obj);
                } else {
                    this.isRemoveDirection = true;
                    this.removeDirectionPosition = position;
                    // this.recipeInfoModel['directions'].splice(position, 1);
                }
                this.validateRecipeForm();
            },

            // Method to add/remove ingredients row
            addRemoveIngredients(position, type){
                if(type == 'add'){
                    if(this.recipeInfoModel['ingredients'].length > 0){
                        position++;
                    }
                    var _obj = {
                        "name": "",
                        "whole_quantity": "0",
                        "partial_quantity": "0",
                        "unit": ""
                    };

                    this.recipeInfoModel['ingredients'].splice(position, 0, _obj);
                } else {
                    this.isRemoveIngredient = true;
                    this.removeIngredientPosition = position;
                    // this.recipeInfoModel['ingredients'].splice(position, 1);
                }
                this.validateRecipeForm();
            },

            // Method to add/remove promotion row
            addRemovePromotions(position, type){
                if(type == 'add'){
                    if(this.recipeInfoModel['promotions'].length > 0){
                        position++;
                    }
                    var _obj = {
                        "name": "",
                        "description": "",
                        "url": "",
                        "image": ""
                    };
                    this.recipeInfoModel['promotions'].splice(position, 0, _obj);
                } else {
                    this.isRemovePromotion = true;
                    this.removePromotionPosition = position;
                }
                this.validateRecipeForm();
            },

            // Method to remove overview after user confirmation
            onConfirmRemoveOverview(value){
                if(value){
                    this.recipeInfoModel['overview'].splice(this.removeOverviewPosition, 1);
                    this.removeOverviewPosition = -1;
                    
                    this.validateRecipeForm();
                }
            },
            
            // Method to remove direction after user confirmation
            onConfirmRemoveDirection(value){
                if(value){
                    this.recipeInfoModel['directions'].splice(this.removeDirectionPosition, 1);
                    this.removeDirectionPosition = -1;
                    this.validateRecipeForm();
                }
            },
            
            // Method to remove Ingredient after user confirmation
            onConfirmRemoveIngredient(value){
                if(value){
                    this.recipeInfoModel['ingredients'].splice(this.removeIngredientPosition, 1);
                    this.removeIngredientPosition = -1;
                    this.validateRecipeForm();
                }
            },
            
            // Method to remove Ingredient after user confirmation
            onConfirmRemovePromotion(value){
                if(value){
                    this.recipeInfoModel['promotions'].splice(this.removePromotionPosition, 1);
                    this.removePromotionPosition = -1;
                    this.validateRecipeForm();
                }
            },
            
            // Method to remove image after user confirmation
            onConfirmRemoveImageVideo(value, type){
                if(value){
                    
                    if(type == 'image'){
                        this.recipeInfoModel['image'] = '';
                    } else if(type == 'video'){
                        this.recipeInfoModel['video'] = '';
                    } else if(type == 'promotionImage'){
                        this.recipeInfoModel['promotions'][this.promotionImageIndex]['image'] = '';
                    }

                    this.validateRecipeForm();
                    if(this.isValidRecipeForm)
                        // this.saveRecipe();
                    
                    this.isRemoveImage = false;
                    this.isRemoveVideo = false;
                    this.isRemovePromotionImage = false;
                }
            },

            // Method to when overview order change
            onOverviewUpdate: function (event) {
                if(this.recipeInfoModel['overview']){
                    this.toggleOverview = false;
                    setTimeout(() => {
                        this.recipeInfoModel['overview'].splice(event.newIndex, 0, this.recipeInfoModel['overview'].splice(event.oldIndex, 1)[0]);
                        this.toggleOverview = true;
                    }, 500);
                }
            },
            
            // Method to when directions order change
            onDirectionUpdate: function (event) {
                if(this.recipeInfoModel['directions']){
                    this.toggleDirection = false;
                    setTimeout(() => {
                        this.recipeInfoModel['directions'].splice(event.newIndex, 0, this.recipeInfoModel['directions'].splice(event.oldIndex, 1)[0]);
                        this.toggleDirection = true;
                    }, 500);
                }
            },

            
            // Method to when ingredients order change
            onIngredientsUpdate: function (event) {
                if(this.recipeInfoModel['ingredients']){
                    this.toggleIngredients = false;
                    setTimeout(() => {
                        this.recipeInfoModel['ingredients'].splice(event.newIndex, 0, this.recipeInfoModel['ingredients'].splice(event.oldIndex, 1)[0]);
                        this.toggleIngredients = true;
                    }, 500);
                }
            },
            
            // Method to when ingredients order change
            onPromotionsUpdate: function (event) {
                if(this.recipeInfoModel['promotions']){
                    this.togglePromotions = false;
                    setTimeout(() => {
                        this.recipeInfoModel['promotions'].splice(event.newIndex, 0, this.recipeInfoModel['promotions'].splice(event.oldIndex, 1)[0]);
                        this.togglePromotions = true;
                    }, 500);
                }
            },

            // Method to when user pick image
            pickImageFile () {
                if(!this.isUploadingImage && !this.isUploadingVideo){
                    this.$refs.image.click ()
                }
            },

            // Method to when user pick promotion image
            pickPromotionImageFile (i) {
                if(!this.isUploadingImage && !this.isUploadingVideo && !this.isUploadingPromotionImage){
                    this.$refs.promotionImage[i].click();
                    this.promotionImageIndex = i;
                } else {
                    this.promotionImageIndex = 0;
                }
            },
            
            // Method to when user pick video
            pickVideoFile () {
                if(!this.isUploadingImage && !this.isUploadingVideo){
                    this.$refs.video.click ()
                }
            },

            // Method call on file picked
            onFilePicked (e, type) {
                const files = e.target.files
                if(files[0] !== undefined) {
                    var _name = files[0].name
                    if(_name.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        if(type == 'image'){
                            this.imageName = _name;
                            // this.imageUrl = fr.result;
                            this.imageFile = files[0] // this is an image file that can be sent to firebase storage...
                        } else if(type == 'video'){
                            this.videoName = _name;
                            // this.videoUrl = fr.result
                            this.videoFile = files[0] // this is an image file that can be firebase storage...
                        } else if(type == 'promotionImage'){
                            this.promotionImageName = _name;
                            // this.videoUrl = fr.result
                            this.promotionImageFile = files[0] // this is an image file that can be firebase storage...
                        }
                        this.uploadImageVideo(type);
                    })
                } else {
                    this.clearImage();
                }
            },
            
            // Method to reset image file values
            clearImage(){
                // this.imageUrl = "";
                this.imageName = "";
                this.imageFile = "";
            },
            
            // Method to reset video file values
            clearVideo(){
                // this.videoUrl = "";
                this.videoName = "";
                this.videoFile = "";
            },

            // Method to upload image or video
            uploadImageVideo(type){
                this.validateRecipeForm();

                if(this.imageFile || this.videoFile || this.promotionImageFile){

                    var _name = (type == 'image')? this.imageName : ((type == 'video')? this.videoName : this.promotionImageName);
                    this.isUploadingImage = (type == 'image')? true : false;
                    this.isUploadingVideo = (type == 'video')? true : false;
                    this.isUploadingPromotionImage = (type == 'promotionImage')? true : false;

                    // var user = firebase.auth().currentUser;
                    var storageRef = firebase.storage().ref(CONSTANT.FIREBASE_STORAGE.RECIPES + Utils.getTimestampByDate() + _name);
    
                    var uploadTask = storageRef.put((type == 'image')? this.imageFile : ((type == 'video')? this.videoFile : this.promotionImageFile));
    
                    uploadTask.on('state_changed', (snapshot) => {
                        var progress = ((snapshot.bytesTransferred / snapshot.totalBytes) * 100).toFixed(2);
                        this.imageUploadProgress = parseInt((type == 'image')? progress : 0);
                        this.promotionImageUploadProgress = parseInt((type == 'promotionImage')? progress : 0);
                        this.videoUploadProgress = parseInt((type == 'video')? progress : 0);
                    }, () => {
                        this.$store.commit("setAlert", {
                            isAlertError: true,
                            message:  (this.id)? CONSTANT.MESSAGES.RECIPE.UPDATE_FAIL : CONSTANT.MESSAGES.RECIPE.UPLOAD_FAIL
                        });
                    }, () => {
                        // Upload complete
                        storageRef.getDownloadURL().then((url) => {
                            if(type == 'image'){
                                this.recipeInfoModel['image'] = url;
                                this.$store.commit("setAlert", {
                                    isAlertSuccess: true,
                                    message: CONSTANT.MESSAGES.RECIPE.IMAGE_UPLOAD_SUCCESS
                                });
                                this.clearImage();
                            } else if(type == 'video'){
                                this.recipeInfoModel['video'] = url;

                                // this.videoUrl = url;
                                this.$store.commit("setAlert", {
                                    isAlertSuccess: true,
                                    message: CONSTANT.MESSAGES.RECIPE.VIDEO_UPLOAD_SUCCESS
                                });
                                this.clearVideo();
                            } else if(type == 'promotionImage'){
                                this.recipeInfoModel['promotions'][this.promotionImageIndex]['image'] = url;

                                // this.videoUrl = url;
                                this.$store.commit("setAlert", {
                                    isAlertSuccess: true,
                                    message: CONSTANT.MESSAGES.RECIPE.IMAGE_UPLOAD_SUCCESS
                                });
                                this.clearVideo();
                            }

                            this.validateRecipeForm();
                            setTimeout(() => {
                                this.isUploadingImage = false;
                                this.isUploadingVideo = false;
                                this.isUploadingPromotionImage = false;
                                // if(this.isValidRecipeForm && this.id)
                                    // this.saveRecipe();
                            }, 1000);
                        });
                    })
                }
            },

            // Method to validate recipe form
            validateRecipeForm() {
                if (!this.recipeInfoModel ||
                    (!this.recipeInfoModel.name ||
                        !this.recipeInfoModel.author ||
                        !this.recipeInfoModel.image ||
                        !this.recipeInfoModel.type ||
                        !this.recipeInfoModel.cook_time ||
                        !this.recipeInfoModel.recipe_level ||
                        !this.recipeInfoModel.publish_status ||
                        !this.recipeInfoModel.skill_level)
                ) {
                    this.isValidRecipeForm = false;

                } else {
                    this.isValidRecipeForm = true;

                    if(this.recipeInfoModel['overview'].length <= 0 || this.recipeInfoModel['directions'].length <= 0 || this.recipeInfoModel['ingredients'].length <= 0){
                        this.isValidRecipeForm = false;
                    } else {
                        this.recipeInfoModel['overview'].forEach((over) => {
                            if(Utils.isNullOrUndefined(over['name'])){
                                this.isValidRecipeForm = false;
                            }
                        });
                        
                        this.recipeInfoModel['directions'].forEach((direct) => {
                            if(Utils.isNullOrUndefined(direct['name'])){
                                this.isValidRecipeForm = false;
                            }
                        });
                        
                        this.recipeInfoModel['ingredients'].forEach((ingred) => {
                            if(Utils.isNullOrUndefined(ingred['name']) || Utils.isNullOrUndefined(ingred['whole_quantity']) || Utils.isNullOrUndefined(ingred['unit'])){
                                this.isValidRecipeForm = false;
                            }
                        });
                        
                        this.recipeInfoModel['promotions'].forEach((ingred) => {
                            if(Utils.isNullOrUndefined(ingred['name']) || Utils.isNullOrUndefined(ingred['description']) || Utils.isNullOrUndefined(ingred['url']) || Utils.isNullOrUndefined(ingred['image'])){
                                this.isValidRecipeForm = false;
                            }
                        });
                    }
                }
            },

            // Method to save recipe
            saveRecipe(){
                if(this.isValidRecipeForm){
                    var directions = this.recipeInfoModel['directions'].map(function(item) {
                        return (item)? item['name'] : '';
                    });
                    
                    var overviews = this.recipeInfoModel['overview'].map(function(item) {
                        return (item)? item['name'] : '';
                    });
    
                    var _recipeInfoModel =  Object.assign({}, this.recipeInfoModel);
    
                    _recipeInfoModel['directions'] = directions;
                    _recipeInfoModel['overview'] = overviews;

                    var _USER = JSON.parse(this.$store.getters.loginUser);
                    _recipeInfoModel['user_id'] = _USER.userId;
    
                    RecipeService.addEditRecipe(
                        _recipeInfoModel,
                        this.id
                    )
                    .then(UUID => {
                        this.$store.commit("setAlert", {
                            isAlertSuccess: true,
                            message: (this.id)? CONSTANT.MESSAGES.RECIPE.UPDATE_SUCCESS : CONSTANT.MESSAGES.RECIPE.ADD_SUCCESS
                        });
    
                        if(!this.id){
                            this.$router.push(
                                `/recipe/${UUID}`
                            );
                        } else {
                            this.checkRecipeChangedOrNot((_isChanged)=>{
                                if(_isChanged){
                                    this.currentRecipeInfoModel = Object.assign({}, this.recipeInfoModel);
                                    // this.manageDateRecipeCollection(this.id);
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$store.commit("setAlert", {
                            isAlertError: true,
                            message:  (this.id)? CONSTANT.MESSAGES.RECIPE.UPDATE_FAIL : CONSTANT.MESSAGES.RECIPE.ADD_FAIL
                        });
                    });
                } else {
                    this.$store.commit("setAlert", {
                        isAlertError: true,
                        message: CONSTANT.MESSAGES.RECIPE.REQUIRED_FIELDS_MISSING
                    });
                }
            },

            checkRecipeChangedOrNot(callback){
                var _isChanged = false;
                if(this.recipeInfoModel['name'] != this.currentRecipeInfoModel['name'] ||
                    this.recipeInfoModel['cook_time'] != this.currentRecipeInfoModel['cook_time'] ||
                    this.recipeInfoModel['image'] != this.currentRecipeInfoModel['image'] ||
                    this.recipeInfoModel['skill_level'] != this.currentRecipeInfoModel['skill_level'] ||
                    this.recipeInfoModel['type'] != this.currentRecipeInfoModel['type'] || 
                    this.recipeInfoModel['weight'] != this.currentRecipeInfoModel['weight']
                    ){
                    _isChanged = true;
                }

                callback(_isChanged);
            },

            manageDateRecipeCollection(updatedRecipeId){
                var dateRecipes = [];
                DateRecipeService.getDateRecipes(
                    recipes => {
                        
                        var counter = 0;
                        if (recipes) {
                            recipes.forEach(doc => {
                                var _obj = doc.data();
                                _obj["id"] = doc.id;
                                dateRecipes.push(_obj);
                                counter++;
                                if(counter < -1){
                                    this.updateDateRecipeCollection(updatedRecipeId, dateRecipes);
                                }
                            });
                        }
                    }
                );
            },

            updateDateRecipeCollection(updatedRecipeId, dateRecipes){
                var _NEW_RECIPES = [];
                dateRecipes.forEach((_recipe) => {
                    var _ID = _recipe['id'];
                    _NEW_RECIPES[_ID] = {};

                    if(_ID){
                        _NEW_RECIPES[_ID][this.BREAKFAST] = [];
                        _NEW_RECIPES[_ID][this.DINNER] = [];
                        _NEW_RECIPES[_ID][this.LUNCH] = [];

                        this.filterRecipeByType(this.BREAKFAST, _recipe[this.BREAKFAST], updatedRecipeId, (_NEW_BREAKFAST) => {
                            _NEW_RECIPES[_ID][this.BREAKFAST].push(_NEW_BREAKFAST);
                        
                            this.filterRecipeByType(this.DINNER, _recipe[this.DINNER], updatedRecipeId, (_NEW_DINNER) => {
                                _NEW_RECIPES[_ID][this.DINNER].push(_NEW_DINNER);

                                this.filterRecipeByType(this.LUNCH, _recipe[this.LUNCH], updatedRecipeId, (_NEW_LUNCH) => {
                                    _NEW_RECIPES[_ID][this.LUNCH].push(_NEW_LUNCH);
                                });
                            });
                        });
                    }
                });
            },

            filterRecipeByType(type, list, updatedRecipeId, callback){

                var _listCounter = 0;
                var _list = [];

                list.forEach((element) => {
                    var _key = Object.keys(element)[0];
                    var _OBJ = {};

                    if(_key == updatedRecipeId){
                        _OBJ[_key] = this.getCurrentRecipeObject(updatedRecipeId);
                        _list.push(_OBJ);
                        _listCounter++;                                
                    } else {
                        _list.push(element);
                        _listCounter++;                                
                    }
                    if(_listCounter >= list.length){
                        callback(_list);   
                    }
                });
            },
            
            getCurrentRecipeObject(updatedRecipeId){
                return {
                    "cook_time": this.recipeInfoModel['cook_time'],
                    "id": updatedRecipeId,
                    "image": this.recipeInfoModel['image'],
                    "name": this.recipeInfoModel['name'],
                    "skill_level": this.recipeInfoModel['skill_level'],
                    "type": this.recipeInfoModel['type']
                };
            },

            // Method to redirect to add recipe page
            goToRecipes() {
                this.$router.push("/recipes");
            },

            // Method to get full formated Date
            parseFirebaseTimestamp(date) {
                return date && date.seconds ?
                    Utils.getFullFormatedDate(date.seconds * 1000) :
                    "";
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
